import { DI, Registration } from '@aurelia/kernel';
import { ValidationHtmlConfiguration, ValidationTrigger } from '@aurelia/validation-html';
import { customAttribute, bindable, INode, valueConverter } from '@aurelia/runtime-html';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
}
function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

let FilledCard = (()=>{
    let _classDecorators = [
        customAttribute({
            name: 'filled-card'
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _radius_decorators;
    let _radius_initializers = [];
    let _radius_extraInitializers = [];
    let _padding_decorators;
    let _padding_initializers = [];
    let _padding_extraInitializers = [];
    let _color_decorators;
    let _color_initializers = [];
    let _color_extraInitializers = [];
    (class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _radius_decorators = [
                bindable({
                    primary: true
                })
            ];
            _padding_decorators = [
                bindable()
            ];
            _color_decorators = [
                bindable()
            ];
            __esDecorate(null, null, _radius_decorators, {
                kind: "field",
                name: "radius",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"radius" in obj,
                    get: (obj)=>obj.radius,
                    set: (obj, value)=>{
                        obj.radius = value;
                    }
                },
                metadata: _metadata
            }, _radius_initializers, _radius_extraInitializers);
            __esDecorate(null, null, _padding_decorators, {
                kind: "field",
                name: "padding",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"padding" in obj,
                    get: (obj)=>obj.padding,
                    set: (obj, value)=>{
                        obj.padding = value;
                    }
                },
                metadata: _metadata
            }, _padding_initializers, _padding_extraInitializers);
            __esDecorate(null, null, _color_decorators, {
                kind: "field",
                name: "color",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"color" in obj,
                    get: (obj)=>obj.color,
                    set: (obj, value)=>{
                        obj.color = value;
                    }
                },
                metadata: _metadata
            }, _color_initializers, _color_extraInitializers);
            __esDecorate(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        }
        element;
        static inject = [
            INode
        ];
        radius = __runInitializers(this, _radius_initializers, 4);
        padding = (__runInitializers(this, _radius_extraInitializers), __runInitializers(this, _padding_initializers, 0));
        color = (__runInitializers(this, _padding_extraInitializers), __runInitializers(this, _color_initializers, '--md-sys-color-surface'));
        constructor(element){
            __runInitializers(this, _color_extraInitializers);
            this.element = element;
            this.element.style.borderRadius = `${this.radius}px`;
            this.element.style.padding = `${this.padding}px`;
            this.element.style.backgroundColor = `var(${this.color})`;
        }
        bound() {
            this.element.style.borderRadius = `${this.radius}px`;
            this.element.style.padding = `${this.padding}px`;
            this.element.style.backgroundColor = `var(${this.color})`;
        }
        static{
            __runInitializers(_classThis, _classExtraInitializers);
        }
    });
    return _classThis;
})();

let Elevation = (()=>{
    let _classDecorators = [
        customAttribute({
            name: 'elevation'
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _elevation_decorators;
    let _elevation_initializers = [];
    let _elevation_extraInitializers = [];
    (class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _elevation_decorators = [
                bindable({
                    primary: true
                })
            ];
            __esDecorate(null, null, _elevation_decorators, {
                kind: "field",
                name: "elevation",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"elevation" in obj,
                    get: (obj)=>obj.elevation,
                    set: (obj, value)=>{
                        obj.elevation = value;
                    }
                },
                metadata: _metadata
            }, _elevation_initializers, _elevation_extraInitializers);
            __esDecorate(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        }
        element;
        static inject = [
            INode
        ];
        elevation = __runInitializers(this, _elevation_initializers, 1);
        constructor(element){
            __runInitializers(this, _elevation_extraInitializers);
            this.element = element;
            this.element.style.boxShadow = this.getShadowForLevel(this.elevation);
        }
        bound() {
            this.element.style.boxShadow = this.getShadowForLevel(this.elevation);
        }
        getShadowForLevel(level) {
            if (level === 0) {
                return 'none';
            }
            const blur = level * 0.5;
            const spread = level * 20;
            return `0px ${blur}px ${spread}px rgba(0, 0, 0, 0.06)`;
        }
        static{
            __runInitializers(_classThis, _classExtraInitializers);
        }
    });
    return _classThis;
})();

const attributes = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
  __proto__: null,
  Elevation,
  FilledCard
}, Symbol.toStringTag, { value: 'Module' }));

let TextTruncateValueConverter = (()=>{
    let _classDecorators = [
        valueConverter('textTruncate')
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    (class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        toView(value, truncateTo) {
            if (value && value.length > truncateTo) {
                return value.substring(0, truncateTo) + '...';
            }
            return value;
        }
    });
    return _classThis;
})();

let ThousandSeparatorValueConverter = (()=>{
    let _classDecorators = [
        valueConverter('thousandSeparator')
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    (class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        toView(value) {
            if (value !== '' && value !== undefined && value !== 0 && value !== '0' && value !== null) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            return value;
        }
    });
    return _classThis;
})();

const valueConverters = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
  __proto__: null,
  TextTruncateValueConverter,
  ThousandSeparatorValueConverter
}, Symbol.toStringTag, { value: 'Module' }));

const IChicksGroupUiComponents = DI.createInterface('IBetsyWebComponentsConfiguration');

class ChicksGroupUiComponentsPlugin {
    #configuration;
    static configure(...args) {
        const instance = new ChicksGroupUiComponentsPlugin();
        if (typeof args[0] === 'function') {
            instance.#configuration = {
                iconMap: new Map()
            };
            args[0](instance.#configuration);
        } else {
            instance.#configuration = args[0];
        }
        if (!instance.#configuration.formatDateTime) {
            instance.#configuration.formatDateTime = (date)=>new Intl.DateTimeFormat('default', {
                    dateStyle: 'full'
                }).format(typeof date === 'string' ? new Date(date) : date);
        }
        if (!instance.#configuration.formatDate) {
            instance.#configuration.formatDate = (date)=>new Intl.DateTimeFormat('default', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                }).format(typeof date === 'string' ? new Date(date) : date);
        }
        if (!instance.#configuration.formatNumber) {
            instance.#configuration.formatNumber = (number)=>new Intl.NumberFormat('default', {
                    maximumFractionDigits: 2
                }).format(number == null ? 0 : Number(number));
        }
        if (!instance.#configuration.formatCurrency) {
            instance.#configuration.formatCurrency = (number)=>new Intl.NumberFormat('default', {
                    style: 'currency',
                    currency: 'usd'
                }).format(number == null ? 0 : Number(number));
        }
        if (!instance.#configuration.formatPercent) {
            instance.#configuration.formatPercent = (number)=>new Intl.NumberFormat('default', {
                    style: 'percent'
                }).format(number == null ? 0 : Number(number));
        }
        return instance;
    }
    register(container) {
        container.register(attributes);
        container.register(valueConverters);
        container.register(Registration.instance(IChicksGroupUiComponents, this.#configuration));
        container.register(ValidationHtmlConfiguration.customize((options)=>{
            options.DefaultTrigger = ValidationTrigger.changeOrFocusout;
        }));
        return container;
    }
}
const defaultInit = ChicksGroupUiComponentsPlugin.configure(()=>{});

export { ChicksGroupUiComponentsPlugin, IChicksGroupUiComponents, attributes, defaultInit, valueConverters };
//# sourceMappingURL=index.js.map
